<div class="title-part">
  <h2 class="title">
    <a *ngIf="route; else elseBlock" [routerLink]="route" class="route">{{ title | customLocale }}</a>
    <ng-template #elseBlock>{{ title | customLocale }}</ng-template>
  </h2>
  <a *ngIf="editRoute" [routerLink]="editRoute" class="edit">{{ editTitle | customLocale }}</a>
  <ng-content select="[side]"></ng-content>
</div>
<a *ngIf="route && more" [routerLink]="route" class="more">{{ more | customLocale }}</a>
